import { ValidationFailure } from "domain/Validations/Models/ValidationFailure";
import { DateTime } from "luxon";

type minMaxMode = "min" | "max" | "mode";

export class ForecastVMErrors {
	constructor(
		public inventoryID: string,
		public errors?: { [key: string]: ValidationFailure[] },
		public start?: DateTime,
		public end?: DateTime
	) {}

	//TODO: Validar método.
	public buildErrorDate(): { [key: string]: { min: {}; max: {}; mode: {} } } {
		const errors = this.errors;

		if (!errors) return {};

		const errorValues = {
			min: {},
			mode: {},
			max: {},
		};

		Object.keys(errors).map((date: string) => {
			const error = errors[date][0];

			const propName = error.propertyName.toLowerCase() as minMaxMode;

			errorValues[propName] = {
				...errorValues[propName],
				[date]: { message: error.errorMessage },
			};
		}, {});

		return { [this.inventoryID]: errorValues };
	}
}
